/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "@/src/services/googleAnalyticsService";

const LpDeathAragMeta = () => {
  const title = "Todesfall & Erbe | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content="Lassen Sie sich als ARAG Kunde bei Legalbird beraten - schnell, einfach und nirgendwo günstiger!" />
      <meta name="keywords" content="Todesfall, Erbe" />
      <meta name="robots" content="noindex,nofollow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Lassen Sie sich als ARAG Kunde bei Legalbird beraten - schnell, einfach und nirgendwo günstiger!" />
    </Helmet>
  );
};

export default LpDeathAragMeta;
